const DEVICE_STATUS = {
    unknown: 'unknown',
    loading: 'loading',
    offline: 'offline',
    online: 'online'
};

const DEVICE_STATUS_STYLE = {
    unknown: { color: 'grey-7', name: 'fas fa-question' },
    loading: { color: 'grey-7', name: 'fas fa-question' },
    offline: {
        color: 'negative',
        name: 'fas fa-times-circle'
    },
    online: { color: 'positive', name: 'fas fa-check-circle' }
};

const PROXIMITY_SENSOR_LABELS = {
    0: {
        label: 'No product in front of sensor',
        value: 0,
        list_icon: 'fal fa-times'
    },
    1: {
        label: 'Product in front of sensor',
        value: 1,
        list_icon: 'fas fa-check-square'
    }
};

const PROXIMITY_SENSOR_OPTIONS = [
    {
        label: 'No product in front of sensor',
        value: 0,
        list_icon: 'fal fa-times'
    },
    {
        label: 'Product in front of sensor',
        value: 1,
        list_icon: 'fas fa-check-square'
    }
];

export {
    DEVICE_STATUS,
    DEVICE_STATUS_STYLE,
    PROXIMITY_SENSOR_OPTIONS,
    PROXIMITY_SENSOR_LABELS
};
